import { flow } from 'fp-ts/function';
import * as RNEA from 'fp-ts/ReadonlyNonEmptyArray';
import * as Str from 'fp-ts/string';
export var stripExtraWords = flow(Str.split(' '), RNEA.head);